$(document).on('click', '.btn-toggle-note', function(){
  $(this).closest('.input-note').toggleClass('active');
  $(this).toggleClass('active');
})